import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

export const matchPortfolioRoadmapConfluenceUri = (url) => {
	const urlPattern = new RegExp(
		/^(https?):\/\/[-a-zA-Z0-9+&@#\/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#\/%=~_|]/,
	);
	return url.indexOf('PortfolioRoadmapConfluence.jspa') !== -1 && url.match(urlPattern);
};

const portfolioforjiraplanPaste = {
	pasteHandler(uri, node, done) {
		const { source } = uri;
		const {
			context: { activeElement = null },
		} = node;
		let macro = null;
		const match = matchPortfolioRoadmapConfluenceUri(source);
		/**
		 * auto-convert of portfolioforjiraplan macro will only be enabled in page edit.
		 * We want to avoid auto-convert in page comment and inline-comment sections.
		 *
		 * We check the the diff of the classList:
		 * Comment sections have this class: 'resizable'
		 * Page edit has these classes: 'fullsize', 'page-edit'
		 */
		if (match && activeElement && activeElement.classList.contains('page-edit')) {
			macro = {
				name: 'portfolioforjiraplan',
				params: {
					url: source,
					planHeight: '700',
				},
			};
		}

		if (macro) {
			window.tinymce.plugins.Autoconvert.convertMacroToDom(macro, done, done);
		} else {
			done();
		}
	},
};

export default function portfolioforjiraplanPasteLink() {
	bind('init.rte', () => {
		window.tinymce.plugins.Autoconvert.autoConvert.addHandler(
			portfolioforjiraplanPaste.pasteHandler,
		);
	});
}
